import { AutoMap } from "@automapper/classes"
import { Prelevement } from "../prelevement"
import { ELocalisationDialyse } from "./enum/localisation-dialyse"
import { EModeDesinfection } from "./enum/mode-desinfection"
import { BaseDOM } from "../base.dom"

export class PrelevementGenerateurDialyse extends BaseDOM<PrelevementGenerateurDialyse>{
    @AutoMap()
    Code: string = ''
    @AutoMap()
    Localisation: ELocalisationDialyse = ELocalisationDialyse.Autre
    @AutoMap()
    Bicarbonate?: number
    @AutoMap()
    Sodium?: number
    @AutoMap()
    AutreLocalisation: string = ''
    @AutoMap()
    Observations!: string;
    @AutoMap()
    Prelevement: Prelevement = new Prelevement()
    @AutoMap()
    ModeDesinfection: EModeDesinfection = EModeDesinfection.Flambage;

}